import React from 'react'
import { useWatch } from 'react-hook-form'
import { FormField } from '../forms/FormField'
import type { FnaFormValues } from '../../contracts/fnaFormSchema'

/**
 * Step 2: Income for client and (conditionally) spouse.
 *
 * @returns JSX.Element The income step
 */
export function IncomeStep(): JSX.Element {
  const withSpouse = useWatch<FnaFormValues, 'withSpouse'>({ name: 'withSpouse' })
  const otherMonthlyIncome = useWatch<FnaFormValues, 'otherMonthlyIncome'>({
    name: 'otherMonthlyIncome',
  })
  const spouseOtherMonthlyIncome = useWatch<FnaFormValues, 'spouseOtherMonthlyIncome'>({
    name: 'spouseOtherMonthlyIncome',
  })
  return (
    <>
      <h2>Income</h2>
      <FormField<FnaFormValues>
        name="annualIncome"
        label="Your annual income"
        type="number"
        placeholder="0"
        inputMode="decimal"
      />
      <FormField<FnaFormValues>
        name="otherMonthlyIncome"
        label="Other monthly income (optional)"
        type="number"
        placeholder="0"
        inputMode="decimal"
      />
      {Number(otherMonthlyIncome) > 0 && (
        <FormField<FnaFormValues>
          name="otherIncomeSource"
          label="Source of other monthly income"
          placeholder="e.g. rental, freelance, dividends"
        />
      )}
      <FormField<FnaFormValues> name="occupation" label="Occupation (optional)" />

      {withSpouse === 'yes' && (
        <>
          <FormField<FnaFormValues>
            name="spouseAnnualIncome"
            label="Spouse's annual income"
            type="number"
            placeholder="0"
            inputMode="decimal"
          />
          <FormField<FnaFormValues>
            name="spouseOtherMonthlyIncome"
            label="Spouse's other monthly income (optional)"
            type="number"
            placeholder="0"
            inputMode="decimal"
          />
          {Number(spouseOtherMonthlyIncome) > 0 && (
            <FormField<FnaFormValues>
              name="spouseOtherIncomeSource"
              label="Source of spouse's other monthly income"
              placeholder="e.g. rental, freelance, dividends"
            />
          )}
          <FormField<FnaFormValues> name="spouseOccupation" label="Spouse's occupation (optional)" />
        </>
      )}
    </>
  )
}
